import React from 'react'; 
import WithConsumer from '../context/WithConsumer';
import GravityForm from "react-gravity-form";
import { Parallax } from 'react-scroll-parallax';
import  { Redirect } from 'react-router-dom';
import Foot from './Foot';

const AccountSettings = ({ context }) => {
		 
    const posts = () => context.posts;
    const post = posts()[0];
    
    if (post) {
	    
	    const ctxUser = () => context.user;
		const user = ctxUser();
	    
    	return (
	    	
	    	<div className="l-block l-block--max-width">
	        	
	        	<div className="l-grid l-grid--large-gutter">
		        	<div className="l-grid__col l-grid__col--m-7-12 l-grid__col--l-6-12 ">
			        	<div className="c-content-block">
			        		<h3 className="c-heading">Edit Your Account</h3>
			        	</div>
		        		<div className="scope-form scope-form--settings">
		        			<GravityForm
								backendUrl={document.location.origin + '/wp-json/bloomingdales/v1/form'}
								formID={post.form}
								populatedFields={{
									first_name: user.first_name,
									last_name: user.last_name,
									company: user.company,
									abn: user.abn,
									street_address: user.street_address,
									city: user.city,
									state: user.state,
									postcode: user.postcode,
									ship_street_address: user.ship_street_address,
									ship_city: user.ship_city,
									ship_state: user.ship_state,
									ship_postcode: user.ship_postcode,
									user_id: user.id,
									user_auth: user.auth_token
								}}
							/>
						</div>
					</div>
					<div className="l-grid__col l-grid__col--m-5-12 l-grid__col--l-6-12">
						<div className="c-content-block scope-text-account">
							<hr />
							{post.help &&
								<div dangerouslySetInnerHTML={ {__html: post.help} }></div>
							}
						</div>
					</div>
				</div>
    		
			</div>
    	)
	    		    	
	} else {
		return null
	}
};
export default WithConsumer(AccountSettings);